// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-98c79945] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.autocomplete-result[data-v-98c79945] {
  display: flex;
  align-items: center;
  gap: var(--default-grid-baseline);
  line-height: 1.2;
  --auto-complete-result-avatar-size: var(--default-clickable-area);
}
.autocomplete-result__icon[data-v-98c79945] {
  position: relative;
  flex: 0 0 var(--default-clickable-area);
  width: var(--default-clickable-area);
  min-width: var(--default-clickable-area);
  height: var(--default-clickable-area);
  border-radius: var(--default-clickable-area);
  background-color: var(--color-background-darker);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}
.autocomplete-result__icon--with-avatar[data-v-98c79945] {
  color: inherit;
  background-size: cover;
}
.autocomplete-result__status[data-v-98c79945] {
  --auto-complete-result-status-icon-size: clamp(14px, var(--auto-complete-result-avatar-size) * 0.4, 18px);
  --auto-complete-result-status-icon-position: calc(var(--auto-complete-result-avatar-size) / 2 * (1 - 1 / sqrt(2)) - var(--auto-complete-result-status-icon-size) / 2);
  box-sizing: border-box;
  position: absolute;
  right: var(--auto-complete-result-status-icon-position);
  bottom: var(--auto-complete-result-status-icon-position);
  height: var(--auto-complete-result-status-icon-size);
  width: var(--auto-complete-result-status-icon-size);
  border: 2px solid var(--color-main-background);
  border-radius: 50%;
  background-color: var(--color-main-background);
  font-size: calc(var(--auto-complete-result-status-icon-size) / 1.2);
  line-height: 1.2;
  background-repeat: no-repeat;
  background-size: var(--auto-complete-result-status-icon-size);
  background-position: center;
}
.autocomplete-result__status--icon[data-v-98c79945] {
  border: none;
  background-color: transparent;
}
.autocomplete-result__content[data-v-98c79945] {
  display: flex;
  flex: 1 1 100%;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
}
.autocomplete-result__title[data-v-98c79945], .autocomplete-result__subline[data-v-98c79945] {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.autocomplete-result__subline[data-v-98c79945] {
  color: var(--color-text-maxcontrast);
}/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-81c31f7c] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.rich-contenteditable[data-v-81c31f7c] {
  position: relative;
  width: auto;
}
.rich-contenteditable__label[data-v-81c31f7c] {
  position: absolute;
  margin-inline: 14px 0;
  max-width: fit-content;
  inset-block-start: 11px;
  inset-inline: 0;
  color: var(--color-text-maxcontrast);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  pointer-events: none;
  transition: height var(--animation-quick), inset-block-start var(--animation-quick), font-size var(--animation-quick), color var(--animation-quick), background-color var(--animation-quick) var(--animation-slow);
}
.rich-contenteditable__input:focus + .rich-contenteditable__label[data-v-81c31f7c], .rich-contenteditable__input:not(.rich-contenteditable__input--empty) + .rich-contenteditable__label[data-v-81c31f7c] {
  inset-block-start: -10px;
  line-height: 1.5;
  font-size: 13px;
  font-weight: 500;
  border-radius: var(--default-grid-baseline) var(--default-grid-baseline) 0 0;
  background-color: var(--color-main-background);
  padding-inline: 5px;
  margin-inline-start: 9px;
  transition: height var(--animation-quick), inset-block-start var(--animation-quick), font-size var(--animation-quick), color var(--animation-quick);
}
.rich-contenteditable__input[data-v-81c31f7c] {
  overflow-y: auto;
  width: auto;
  margin: 0;
  padding: 8px;
  cursor: text;
  white-space: pre-wrap;
  word-break: break-word;
  color: var(--color-main-text);
  border: 2px solid var(--color-border-maxcontrast);
  border-radius: var(--border-radius-large);
  outline: none;
  background-color: var(--color-main-background);
  font-family: var(--font-face);
  font-size: inherit;
  min-height: var(--default-clickable-area);
  max-height: calc(var(--default-clickable-area) * 5.5);
}
.rich-contenteditable__input--has-label[data-v-81c31f7c] {
  margin-top: 10px;
}
.rich-contenteditable__input--empty[data-v-81c31f7c]:focus:before, .rich-contenteditable__input--empty[data-v-81c31f7c]:not(.rich-contenteditable__input--has-label):before {
  content: attr(aria-placeholder);
  color: var(--color-text-maxcontrast);
  position: absolute;
}
.rich-contenteditable__input[contenteditable=false][data-v-81c31f7c]:not(.rich-contenteditable__input--disabled) {
  cursor: default;
  background-color: transparent;
  color: var(--color-main-text);
  border-color: transparent;
  opacity: 1;
  border-radius: 0;
}
.rich-contenteditable__input--multiline[data-v-81c31f7c] {
  min-height: calc(var(--default-clickable-area) * 3);
  max-height: none;
}
.rich-contenteditable__input--disabled[data-v-81c31f7c] {
  opacity: 0.5;
  color: var(--color-text-maxcontrast);
  border: 2px solid var(--color-background-darker);
  border-radius: var(--border-radius);
  background-color: var(--color-background-dark);
}/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
._material-design-icon_1o935_12 {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
._tribute-container_1o935_20 {
  z-index: 9000;
  overflow: auto;
  position: absolute;
  left: -10000px;
  margin: var(--default-grid-baseline) 0;
  padding: var(--default-grid-baseline);
  color: var(--color-text-maxcontrast);
  border-radius: var(--border-radius-element, var(--border-radius));
  background: var(--color-main-background);
  box-shadow: 0 1px 5px var(--color-box-shadow);
}
._tribute-container_1o935_20, ._tribute-container_1o935_20 * {
  box-sizing: border-box;
}
._tribute-container_1o935_20 ul {
  display: flex;
  flex-direction: column;
  gap: var(--default-grid-baseline);
}
._tribute-container_1o935_20 ._tribute-container__item_1o935_40 {
  color: var(--color-text-maxcontrast);
  border-radius: var(--border-radius-small, var(--border-radius));
  padding: var(--default-grid-baseline);
  cursor: pointer;
  min-height: var(--clickable-area-small, auto);
}
._tribute-container_1o935_20 ._tribute-container__item_1o935_40.highlight {
  color: var(--color-main-text);
  background: var(--color-background-hover);
}
._tribute-container_1o935_20 ._tribute-container__item_1o935_40.highlight, ._tribute-container_1o935_20 ._tribute-container__item_1o935_40.highlight * {
  cursor: pointer;
}
._tribute-container_1o935_20._tribute-container--focus-visible_1o935_54 .highlight._tribute-container__item_1o935_40 {
  outline: 2px solid var(--color-main-text) !important;
}
._tribute-container-autocomplete_1o935_58 {
  min-width: 250px;
  max-width: 300px;
  max-height: calc((var(--default-clickable-area) + 3 * var(--default-grid-baseline)) * 4.5 - 1.5 * var(--default-grid-baseline));
}
._tribute-container-emoji_1o935_64,
._tribute-container-link_1o935_65 {
  min-width: 200px;
  max-width: 200px;
  max-height: calc((24px + 3 * var(--default-grid-baseline)) * 5.5 - 1.5 * var(--default-grid-baseline));
}
._tribute-container-emoji_1o935_64 ._tribute-item_1o935_70,
._tribute-container-link_1o935_65 ._tribute-item_1o935_70 {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
._tribute-container-link_1o935_65 {
  min-width: 200px;
  max-width: 300px;
}
._tribute-container-link_1o935_65 ._tribute-item_1o935_70 {
  display: flex;
  align-items: center;
}
._tribute-container-link_1o935_65 ._tribute-item__title_1o935_85 {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
._tribute-container-link_1o935_65 ._tribute-item__icon_1o935_90 {
  margin: auto 0;
  width: 20px;
  height: 20px;
  object-fit: contain;
  padding-right: var(--default-grid-baseline);
  filter: var(--background-invert-if-dark);
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcRichContenteditable-DkYYyQTJ.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,iCAAiC;EACjC,gBAAgB;EAChB,iEAAiE;AACnE;AACA;EACE,kBAAkB;EAClB,uCAAuC;EACvC,oCAAoC;EACpC,wCAAwC;EACxC,qCAAqC;EACrC,4CAA4C;EAC5C,gDAAgD;EAChD,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;AAC1B;AACA;EACE,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,yGAAyG;EACzG,qKAAqK;EACrK,sBAAsB;EACtB,kBAAkB;EAClB,uDAAuD;EACvD,wDAAwD;EACxD,oDAAoD;EACpD,mDAAmD;EACnD,8CAA8C;EAC9C,kBAAkB;EAClB,8CAA8C;EAC9C,mEAAmE;EACnE,gBAAgB;EAChB,4BAA4B;EAC5B,6DAA6D;EAC7D,2BAA2B;AAC7B;AACA;EACE,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,oCAAoC;AACtC,CAAC;;;EAGC;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,kNAAkN;AACpN;AACA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,4EAA4E;EAC5E,8CAA8C;EAC9C,mBAAmB;EACnB,wBAAwB;EACxB,mJAAmJ;AACrJ;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;EACtB,6BAA6B;EAC7B,iDAAiD;EACjD,yCAAyC;EACzC,aAAa;EACb,8CAA8C;EAC9C,6BAA6B;EAC7B,kBAAkB;EAClB,yCAAyC;EACzC,qDAAqD;AACvD;AACA;EACE,gBAAgB;AAClB;AACA;EACE,+BAA+B;EAC/B,oCAAoC;EACpC,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,6BAA6B;EAC7B,6BAA6B;EAC7B,yBAAyB;EACzB,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,mDAAmD;EACnD,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,oCAAoC;EACpC,gDAAgD;EAChD,mCAAmC;EACnC,8CAA8C;AAChD,CAAC;;;EAGC;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,sCAAsC;EACtC,qCAAqC;EACrC,oCAAoC;EACpC,iEAAiE;EACjE,wCAAwC;EACxC,6CAA6C;AAC/C;AACA;EACE,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,iCAAiC;AACnC;AACA;EACE,oCAAoC;EACpC,+DAA+D;EAC/D,qCAAqC;EACrC,eAAe;EACf,6CAA6C;AAC/C;AACA;EACE,6BAA6B;EAC7B,yCAAyC;AAC3C;AACA;EACE,eAAe;AACjB;AACA;EACE,oDAAoD;AACtD;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,+HAA+H;AACjI;AACA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,sGAAsG;AACxG;AACA;;EAEE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,2CAA2C;EAC3C,wCAAwC;AAC1C","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-98c79945] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.autocomplete-result[data-v-98c79945] {\n  display: flex;\n  align-items: center;\n  gap: var(--default-grid-baseline);\n  line-height: 1.2;\n  --auto-complete-result-avatar-size: var(--default-clickable-area);\n}\n.autocomplete-result__icon[data-v-98c79945] {\n  position: relative;\n  flex: 0 0 var(--default-clickable-area);\n  width: var(--default-clickable-area);\n  min-width: var(--default-clickable-area);\n  height: var(--default-clickable-area);\n  border-radius: var(--default-clickable-area);\n  background-color: var(--color-background-darker);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n}\n.autocomplete-result__icon--with-avatar[data-v-98c79945] {\n  color: inherit;\n  background-size: cover;\n}\n.autocomplete-result__status[data-v-98c79945] {\n  --auto-complete-result-status-icon-size: clamp(14px, var(--auto-complete-result-avatar-size) * 0.4, 18px);\n  --auto-complete-result-status-icon-position: calc(var(--auto-complete-result-avatar-size) / 2 * (1 - 1 / sqrt(2)) - var(--auto-complete-result-status-icon-size) / 2);\n  box-sizing: border-box;\n  position: absolute;\n  right: var(--auto-complete-result-status-icon-position);\n  bottom: var(--auto-complete-result-status-icon-position);\n  height: var(--auto-complete-result-status-icon-size);\n  width: var(--auto-complete-result-status-icon-size);\n  border: 2px solid var(--color-main-background);\n  border-radius: 50%;\n  background-color: var(--color-main-background);\n  font-size: calc(var(--auto-complete-result-status-icon-size) / 1.2);\n  line-height: 1.2;\n  background-repeat: no-repeat;\n  background-size: var(--auto-complete-result-status-icon-size);\n  background-position: center;\n}\n.autocomplete-result__status--icon[data-v-98c79945] {\n  border: none;\n  background-color: transparent;\n}\n.autocomplete-result__content[data-v-98c79945] {\n  display: flex;\n  flex: 1 1 100%;\n  flex-direction: column;\n  justify-content: center;\n  min-width: 0;\n}\n.autocomplete-result__title[data-v-98c79945], .autocomplete-result__subline[data-v-98c79945] {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.autocomplete-result__subline[data-v-98c79945] {\n  color: var(--color-text-maxcontrast);\n}/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-81c31f7c] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.rich-contenteditable[data-v-81c31f7c] {\n  position: relative;\n  width: auto;\n}\n.rich-contenteditable__label[data-v-81c31f7c] {\n  position: absolute;\n  margin-inline: 14px 0;\n  max-width: fit-content;\n  inset-block-start: 11px;\n  inset-inline: 0;\n  color: var(--color-text-maxcontrast);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  pointer-events: none;\n  transition: height var(--animation-quick), inset-block-start var(--animation-quick), font-size var(--animation-quick), color var(--animation-quick), background-color var(--animation-quick) var(--animation-slow);\n}\n.rich-contenteditable__input:focus + .rich-contenteditable__label[data-v-81c31f7c], .rich-contenteditable__input:not(.rich-contenteditable__input--empty) + .rich-contenteditable__label[data-v-81c31f7c] {\n  inset-block-start: -10px;\n  line-height: 1.5;\n  font-size: 13px;\n  font-weight: 500;\n  border-radius: var(--default-grid-baseline) var(--default-grid-baseline) 0 0;\n  background-color: var(--color-main-background);\n  padding-inline: 5px;\n  margin-inline-start: 9px;\n  transition: height var(--animation-quick), inset-block-start var(--animation-quick), font-size var(--animation-quick), color var(--animation-quick);\n}\n.rich-contenteditable__input[data-v-81c31f7c] {\n  overflow-y: auto;\n  width: auto;\n  margin: 0;\n  padding: 8px;\n  cursor: text;\n  white-space: pre-wrap;\n  word-break: break-word;\n  color: var(--color-main-text);\n  border: 2px solid var(--color-border-maxcontrast);\n  border-radius: var(--border-radius-large);\n  outline: none;\n  background-color: var(--color-main-background);\n  font-family: var(--font-face);\n  font-size: inherit;\n  min-height: var(--default-clickable-area);\n  max-height: calc(var(--default-clickable-area) * 5.5);\n}\n.rich-contenteditable__input--has-label[data-v-81c31f7c] {\n  margin-top: 10px;\n}\n.rich-contenteditable__input--empty[data-v-81c31f7c]:focus:before, .rich-contenteditable__input--empty[data-v-81c31f7c]:not(.rich-contenteditable__input--has-label):before {\n  content: attr(aria-placeholder);\n  color: var(--color-text-maxcontrast);\n  position: absolute;\n}\n.rich-contenteditable__input[contenteditable=false][data-v-81c31f7c]:not(.rich-contenteditable__input--disabled) {\n  cursor: default;\n  background-color: transparent;\n  color: var(--color-main-text);\n  border-color: transparent;\n  opacity: 1;\n  border-radius: 0;\n}\n.rich-contenteditable__input--multiline[data-v-81c31f7c] {\n  min-height: calc(var(--default-clickable-area) * 3);\n  max-height: none;\n}\n.rich-contenteditable__input--disabled[data-v-81c31f7c] {\n  opacity: 0.5;\n  color: var(--color-text-maxcontrast);\n  border: 2px solid var(--color-background-darker);\n  border-radius: var(--border-radius);\n  background-color: var(--color-background-dark);\n}/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n._material-design-icon_1o935_12 {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n._tribute-container_1o935_20 {\n  z-index: 9000;\n  overflow: auto;\n  position: absolute;\n  left: -10000px;\n  margin: var(--default-grid-baseline) 0;\n  padding: var(--default-grid-baseline);\n  color: var(--color-text-maxcontrast);\n  border-radius: var(--border-radius-element, var(--border-radius));\n  background: var(--color-main-background);\n  box-shadow: 0 1px 5px var(--color-box-shadow);\n}\n._tribute-container_1o935_20, ._tribute-container_1o935_20 * {\n  box-sizing: border-box;\n}\n._tribute-container_1o935_20 ul {\n  display: flex;\n  flex-direction: column;\n  gap: var(--default-grid-baseline);\n}\n._tribute-container_1o935_20 ._tribute-container__item_1o935_40 {\n  color: var(--color-text-maxcontrast);\n  border-radius: var(--border-radius-small, var(--border-radius));\n  padding: var(--default-grid-baseline);\n  cursor: pointer;\n  min-height: var(--clickable-area-small, auto);\n}\n._tribute-container_1o935_20 ._tribute-container__item_1o935_40.highlight {\n  color: var(--color-main-text);\n  background: var(--color-background-hover);\n}\n._tribute-container_1o935_20 ._tribute-container__item_1o935_40.highlight, ._tribute-container_1o935_20 ._tribute-container__item_1o935_40.highlight * {\n  cursor: pointer;\n}\n._tribute-container_1o935_20._tribute-container--focus-visible_1o935_54 .highlight._tribute-container__item_1o935_40 {\n  outline: 2px solid var(--color-main-text) !important;\n}\n._tribute-container-autocomplete_1o935_58 {\n  min-width: 250px;\n  max-width: 300px;\n  max-height: calc((var(--default-clickable-area) + 3 * var(--default-grid-baseline)) * 4.5 - 1.5 * var(--default-grid-baseline));\n}\n._tribute-container-emoji_1o935_64,\n._tribute-container-link_1o935_65 {\n  min-width: 200px;\n  max-width: 200px;\n  max-height: calc((24px + 3 * var(--default-grid-baseline)) * 5.5 - 1.5 * var(--default-grid-baseline));\n}\n._tribute-container-emoji_1o935_64 ._tribute-item_1o935_70,\n._tribute-container-link_1o935_65 ._tribute-item_1o935_70 {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n._tribute-container-link_1o935_65 {\n  min-width: 200px;\n  max-width: 300px;\n}\n._tribute-container-link_1o935_65 ._tribute-item_1o935_70 {\n  display: flex;\n  align-items: center;\n}\n._tribute-container-link_1o935_65 ._tribute-item__title_1o935_85 {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n._tribute-container-link_1o935_65 ._tribute-item__icon_1o935_90 {\n  margin: auto 0;\n  width: 20px;\n  height: 20px;\n  object-fit: contain;\n  padding-right: var(--default-grid-baseline);\n  filter: var(--background-invert-if-dark);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
